const { fetchJSON } = window.BAO.Utils

class HarperCartCta extends window.BAO.CustomElement() {
  constructor () {
    super();
    this.harperCartConfig = {
        ctaElement: '#harper-cart-cta',
        platform: 'shopify',
        env: 'production', // use 'staging' if you are using a test store
        "styles": {
          "btnRoundedCorners": "0px",
          "ctaMargin": "15px 0px 0px 0px",
          "btnPrimaryFont": "var(--Font_Family-body);",
          "btnPrimaryFontWeight": "500",
          "btnPrimaryFontSize": ".929rem",
          "btnPrimaryTextTransform": "uppercase",
          "btnPrimaryPadding": "18px 30px 19px",
          "btnPrimaryTextColor": "#1e1e1e",
          "btnPrimaryBGColor": "#ffffff",
          "btnPrimaryBorder": "1px solid #1e1e1e",
          "btnSecondaryBGColor": "#ffffff",
          "btnSecondaryTextColor": "#1e1e1e",
          "btnAnimationBGColor": "#1e1e1e",
          "btnAnimationTextColor": "#ffffff",
          "btnAnimationBorder": "",
          "modalHeaderFont": "var(--Font_Family-headings);",
          "modalPrimaryFont": "var(--Font_Family-body);"
        },
        "options": {
          "showFooterText": true,
          "questionMarkPosition": "text",
          "ctaButtonAnimation": "flash"
        },
    };
    this.scriptId = 'harper-script'; 
  }
  
  
  async connectedCallback () {
    super.connectedCallback()
    const partnerPid = this.getAttribute('partner-pid');
    if (!partnerPid) {
      console.error('HarperLoaderElement: "partner-pid" attribute is required.');
      return;
    }

    const scriptSrc = `https://p.harperstatic.com/client/${partnerPid}-en-gb.js`;

    try {
      // Await the script loading
      await this.loadScript(scriptSrc);

      //console.log(`Harper script (${partnerPid}) loaded successfully.`);
      
      // Dispatch a custom event to notify that the script is loaded
      this.dispatchEvent(new Event('harper-loaded'));
      this.showCartCta();
    } catch (error) {
      console.error('Error loading Harper script:', error);
    }
  }

  loadScript(src) {
    return new Promise((resolve, reject) => {
      // Check if the script is already loaded
      if (document.getElementById(this.scriptId)) {
        //console.log('Script already loaded.');
        resolve();
        return;
      }

      // Create a new script element
      const script = document.createElement('script');
      script.id = this.scriptId;
      script.src = src;
      script.defer = true;

      // Set up event listeners
      script.onload = () => resolve();
      script.onerror = (err) => reject(err);

      // Append the script to the document head
      document.head.appendChild(script);
    });
  }
  
  showCartCta () {
    const cta = document.createElement('div');
    cta.id = 'harper-cart-cta';
    this.appendChild(cta);
    // console.log('HarperCta showCartCta');
    window.harperMiniCart = new Harper(this.harperCartConfig);
  }
}

if (!customElements.get('harper-cart-cta')) {
  customElements.define('harper-cart-cta', HarperCartCta)
}
